import { createElement, Fragment } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const BluetoothSearch = createSvg({
  name: 'bluetooth-search',
  path: /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement("path", {
    d: "M42.75 13.75c-15.16 0-27.5 12.34-27.5 27.5h-1.5c0 15.99 13.01 29 29 29v-1.5c15.16 0 27.5-12.34 27.5-27.5s-12.34-27.5-27.5-27.5zm0 52v-1.5c-12.68 0-23-10.32-23-23h-1.5c0-13.51 10.99-24.5 24.5-24.5s24.5 10.99 24.5 24.5-10.99 24.5-24.5 24.5z"
  }), /*#__PURE__*/createElement("path", {
    d: "M51.52 33.48c0-.38-.15-.77-.44-1.06l-7.91-7.9c-.14-.14-.31-.25-.49-.33-.01 0-.01 0-.02-.01a1.42 1.42 0 00-.55-.11c-.19 0-.38.04-.55.11-.01 0-.02 0-.02.01-.37.15-.66.45-.82.82 0 .01 0 .01-.01.02-.07.17-.11.35-.11.55V37.7l-6.5-6.5c-.59-.59-1.54-.59-2.12 0s-.59 1.54 0 2.12l8.04 8.04-8.08 8.08a1.49 1.49 0 000 2.12c.29.29.68.44 1.06.44s.77-.15 1.06-.44L40.62 45v12.12c0 .19.04.38.11.55 0 .01 0 .02.01.02.15.37.45.66.82.82.01 0 .02 0 .02.01a1.42 1.42 0 001.1 0c.01 0 .02 0 .02-.01.19-.08.35-.19.49-.33l7.91-7.91c.59-.59.59-1.54 0-2.12l-6.81-6.81 6.81-6.81c.28-.29.42-.67.42-1.05zm-3.62 0l-4.29 4.29V29.2l4.29 4.28zm-4.28 11.45l4.29 4.29-4.29 4.29v-8.58z"
  }))
});

export default BluetoothSearch;
